export const REACT_APP_REGION = process.env.REACT_APP_REGION;
export const REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const REACT_APP_ACCESS_KEY_ID = process.env.REACT_APP_ACCESS_KEY_ID;
export const REACT_APP_SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;